import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'

import media from 'media'
import VideoModal from '@anvilco-pkg/ui/components/video/VideoModal'

import PostHero from 'components/blog/PostHero'
import TitleContainer from 'components/Article/TitleContainer'
import { MAX_WIDTH } from 'components/Article'
import SocialShareButtons from 'components/SocialShareButtons'
import PlayButton from 'components/PlayButton'

import { BLOG_SLUG } from 'consts'

const Container = styled(Flex).attrs({
  alignItems: 'center',
  flexDirection: ['column-reverse', 'column-reverse', 'row'],
})`
  ${media.desktop`
    & > *:first-child {
      padding: 0 50px;
    }
  `}

  ${media.beyondGiant`
      & > *:first-child {
        padding-left: 0;
      }
  `}
`

const StyledPostHero = styled(PostHero)`
  width: 100%;

  ${media.desktop`
    width: 50%;
  `}
`

const StyledTitleContainer = styled(TitleContainer)`
  max-width: ${MAX_WIDTH}px;
  padding: 20px;
  padding-bottom: 0;

  .arrow-link {
    display: none;
  }

  ${media.desktop`
    width: 50%;
    .title-containter-tag {
      margin-top: 0;
    }
    padding-left: 0;
  `}

  ${media.giant`
    padding: 0;
    max-width: unset;

    .arrow-link {
        display: flex;
    }
`}
`

const VideoAssetContainer = styled(Box)`
  position: relative;
  cursor: pointer;
  width: 100%;

  ${media.desktop`
    width: 50%;
  `}
`

const VideoAssetInner = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
`

const StyledPostVideoHero = styled(PostHero)`
  width: 100%;
`

const renderHeroImage = ({ image, imageAltText, video }) => {
  if (video) {
    return (
      <VideoModal
        title={video.title}
        videoId={video.videoId}
        renderPlaceholder={({ onClick }) => {
          return (
            <VideoAssetContainer onClick={onClick}>
              <VideoAssetInner>
                <PlayButton />
                <StyledPostVideoHero
                  image={image}
                  title={imageAltText || 'Post hero image'}
                />
              </VideoAssetInner>
            </VideoAssetContainer>
          )
        }}
      />
    )
  }
  return (
    <StyledPostHero image={image} title={imageAltText || 'Post hero image'} />
  )
}

export default function BlogHeader ({
  title,
  author,
  date,
  summary,
  image,
  imageAltText,
  path,
  selectedTag,
  video,
}) {
  return (
    <Container>
      <StyledTitleContainer
        title={title}
        author={author}
        date={date}
        summary={summary}
        selectedTag={selectedTag}
        link={{
          to: `/${BLOG_SLUG}/`,
          text: 'Back to all articles',
        }}
        renderBottom={() => (
          <SocialShareButtons
            title={title}
            summary={summary}
            path={path}
            mt={[24]}
          />
        )}
      />
      {renderHeroImage({ image, imageAltText, video })}
    </Container>
  )
}
